import React, { FC, HTMLAttributes, ReactNode } from 'react';
import styles from './Modal.module.scss';
import useRemoveBodyScroll from '@/components/houses/_hooks/useRemoveBodyScroll';
import { createPortal } from 'react-dom';
interface ModalProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  open: boolean;
  onClose: () => void;
  maxWidth?: string;
  data_cy?: string;
  className?: string;
}
const Modal: FC<ModalProps> = ({
  children,
  open,
  onClose,
  maxWidth = '50vw',
  data_cy,
  className = '',
  ...props
}) => {
  useRemoveBodyScroll(open);
  if (!open) {
    return null;
  }
  return createPortal(<div {...props} className={`${styles['modal']} ${open ? styles['show-modal'] : ''} ${className}`} onClick={onClose} data-cy={data_cy}>
      <div className={styles['modal-content']} style={{
      maxWidth
    }} onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>, document.body);
};
export default Modal;